<!--法律诉讼详情-->
<template>
  <div class="legal" :style="'min-height:'+heightH+'px'">
    <header-index/>
    <div class="legal-content">
      <div class="legal-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="back">企业详情</a></el-breadcrumb-item>
          <el-breadcrumb-item>文书详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="legal-details">
        <el-row class="enterpriseBase" style="background: white;padding-bottom: 50pt;">
          <el-col :span="24" style="padding: 40px;text-align: center;font-size: 24px;">{{ documentTitle }}</el-col>
          <el-col :span="24" style="padding: 0px 40px 30px;font-size: 18px;font-weight: bold;">文书正文</el-col>
          <el-col :span="24" style="padding: 0px 40px 30px;" v-html="documentText"></el-col>
        </el-row>
        <div class="Tips-Things">声明：帮企网利用算法自动分析并生成特定裁判文书标签，仅供用户参考。因文书信息庞杂，无法保证该标签准确反映案件全部信息。如您认为</div>
      </el-row>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import {getLegalProceedingsDetailsByid} from '@/api/enterpriseDetailsApi'
import HeaderIndex from "@/components/header/headerIndex";
import cityJson from "@/static/cityJson.json";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
export default {
  name: "legalProceedingsDetail",
  components: {Hang, Home_footer, HeaderIndex},
  data() {
    return {
      documentTitle: '',
      documentText: '',
      cityList:{},
      id: '',
      /*公司id*/
      corpId: 0,
      heightH: document.documentElement.clientHeight,
    }
  },
  methods: {
    initHtml() {
      getLegalProceedingsDetailsByid({'id': this.$route.query.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content)
          this.documentTitle = res.content.title;
          if (res.content.artical!=''){
            let artical = JSON.parse(res.content.artical.replace("\\u005c", ""));
            this.documentText = '<div style="color: #333333;font-size: 16px;font-weight: bold;line-height: 28px;">法院观点</div>' +
                '<div style="color: #333333;font-size: 16px;line-height: 28px;">' + artical.court_think + '</div>' +
                '<br/><div style="color: #333333;font-size: 16px;font-weight: bold;line-height: 28px;">案件结果</div>' +
                '<div style="color: #333333;font-size: 16px;line-height: 28px;">' + artical.referee_result + '</div><br/>' +
                '<div style="color: #333333;font-size: 16px;line-height: 28px;">' + artical.factual_basis + '</div>';
          }
        }
      })
    },
    back(){
      window.history.back();
    }
  },
  mounted() {
    this.corpId = this.$route.query.corpId;
    this.id = this.$route.query.id;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    this.initHtml();
  }
}
</script>
<style scoped>
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__inner a,
.legal >>> .legal-content .legal-details-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.legal {
  background: #ECEEF5;
  /*头部条样式*/
  .container-header {
    background: #081961;
    padding: 20px 15%;
    color: white;
    font-size: 16px;
    font-weight: bold;
  }

  /*企业基本信息css样式*/
  .legal-content {
    padding: 20px 15% 10px;
    background: #ECEEF5;
    min-width: 76rem;
    .legal-details {
      overflow: auto;
      margin-top: 20px;
    }

    .legal-details::-webkit-scrollbar {
      width: 4px;
    }

    .legal-details::-webkit-scrollbar-thumb {
      height: 8px;
      border-radius: 8px;
      background-color: #999999;
    }
  }
  .Tips-Things {
    color: #666666;
    font-size: 14px;
    margin-top: 20px;
  }
}
</style>